<template lang="html">
  <nav style="transition: none;">
    <ul>
      <li class="mm-listitem">
        <font-awesome-icon class="category-icon" :icon="[ 'fas', 'home' ]" />
        <router-link
          class="mm-listitem__text closeonclick"
          @click.native="checkIfHome"
          :to="{ name: 'home' }">
          Inicio
        </router-link>
      </li>
      <li class="mm-listitem">
        <font-awesome-icon class="category-icon" :icon="[ 'fas', 'history' ]" />
        <router-link
          class="mm-listitem__text closeonclick"
          @click.native="pushToDataLayer('Side menu', 'Latest publications')"
          :to="{ path: '/categoria/todas', query: latestPublicationsQuery }">
          Última semana
        </router-link>
      </li>
      <template v-for="(cat, index) in cats">
        <li :key="index">
          <font-awesome-icon class="category-icon" :icon="[ 'fas', `${ cat.icon }` ]" />
          <router-link
            class="mm-listitem__text closeonclick"
            @click.native="pushToDataLayer('Side menu', cat.name)"
            :to="{ path: `/categoria${cat.action}`, query: filters(cat) }">
            {{ cat.name }}
          </router-link>
          <ul v-if="cat.childs">
            <template v-for="(cat2, in2) in cat.childs">
              <li :key="in2">
                <router-link
                  class="mm-listitem__text closeonclick"
                  @click.native="pushToDataLayer('Side menu 2nd', cat2.name)"
                  :to="{ path: `/categoria${cat2.action}`, query: filters(cat2) }">
                  {{ cat2.name }}
                </router-link>
                <ul v-if="cat2.childs">
                  <template v-for="(cat3, in3) in cat2.childs" >
                    <li :key="in3">
                      <router-link
                        class="mm-listitem__text closeonclick"
                        @click.native="pushToDataLayer('Side menu 3rd', cat3.name)"
                        :to="{ path: `/categoria${cat3.action}`, query: filters(cat3) }">
                        {{ cat3.name }}
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
import $ from 'jquery'
import 'jquery.mmenu'
import 'jquery.mmenu/dist/jquery.mmenu.css'
import categoriesMixin from '@/mixins/categories'
import store from '@/store'

export default {
  mixins: [
    categoriesMixin
  ],

  props: {
    categories: Array,
    menuTitle: String
  },

  data: () => ({
    cats: []
  }),

  watch: {
    categories (cats) {
      if (cats.length === 0) return cats
      this.flattenCats = this.slugParentFlattenCategories(cats)
      this.cats = this.recursiveSlugifyCats(cats)
    }
  },

  created () {
    if (this.categories.length > 0) {
      this.flattenCats = this.slugParentFlattenCategories(this.categories)
      this.cats = this.recursiveSlugifyCats(JSON.parse(JSON.stringify(this.categories)))
    }
  },

  mounted () {
    // Fires mmenu plugin
    const $el = $(this.$el)
    $el.mmenu({
      navbar: {
        title: this.menuTitle
      },
      screenReader: {
        aria: true,
        text: false //show the anchors readers text (like "Open submenu")
      }
    })
    const api = $el.data('mmenu')

    $el.find('.closeonclick').on('click', e => {
      api.close()
      setTimeout( () => {
        api.closeAllPanels()
      }, 500)
    })
  },

  computed: {
    location () {
      return {
        ...store.state.location,
        distance: store.state.search.distance,
        city: store.state.currentCity
      }
    },

    latestPublicationsQuery () {
      return {
        ...this.filters,
        'sort_by_date_Ordenar por': 'más reciente_desc'
      }
    }
  },

  methods: {
    checkIfHome () {
      if (this.$route.name === 'home') {
        store.dispatch('setRefreshHome', true)
        window.scrollTo(0, 0)
      }
    },

    filters (details) {
      return {
        'category_Categorías': `${details.name}_${details.id}`,
        ...JSON.parse(JSON.stringify(this.location)),
        page: 1
      } || {}
    },
  }
}
</script>

<style lang="scss">
  #side-menu li > img {
    height: 2rem;
    margin: auto;
    padding-left: 0.5rem;
  }

  .category-icon {
    width: 35px !important;
    height: 25px;
    margin: auto;
    margin-left: 5px;
    color: #199348;
  }


</style>



// WEBPACK FOOTER //
// src/components/categories/SideMenu.vue